import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3000';
const BASE = `${API_BASE}/webtool/addons`;

export async function listAddons({ q, page = 1, limit = 20 }) {
  const res = await axios.get(BASE, { params: { q: q ?? '', page, limit } });
  return res.data;
}

export async function createAddon(formData) {
  // formData = FormData (title, text, files[], imgs[])
  const res = await axios.post(BASE, formData);
  return res.data;
}

export async function updateAddon(id, formData) {
  // formData = FormData (title, text, imgs_keep, downloads, imgs[])
  const res = await axios.put(`${BASE}/${id}`, formData);
  return res.data;
}

export async function deleteAddon(id) {
  await axios.delete(`${BASE}/${id}`);
}